import { DealerSettingDTO } from 'src/services/generated/api.generated.v1';
import { MutationTree } from 'vuex';
import { SettingStateInterface } from './state';

const mutation: MutationTree<SettingStateInterface> = {
  updateSettingState(state: SettingStateInterface, settings: DealerSettingDTO | null) {
    state.allowedFileUploadExtensions = settings?.allowedFileUploadExtensions ?? null;
    state.maxFileUploadSizeInMegaBytes = settings?.maxFileUploadSizeInMegaBytes ?? null;
    state.dealerStoreUrl = settings?.dealerStoreURL ?? null;
    state.hrvRegistrations = settings?.hrvRegistrationsEmail ?? null;
    state.dcrvRegistrations = settings?.dcrvRegistrationsEmail ?? null;
  }
}


export default mutation;